'use strict'

const u = require('universalify').fromPromise
module.exports = {
  copy: u(require('./copy')),
  copySync: require('./copy-sync')
}
